<div class="section" *ngIf="allowedMethods?.length > 1">
  <p>{{'REGISTER.AUTHENTICATION.TEXT' | translate}} <mat-icon class="helpIcon" matTooltip="{{'REGISTER.AUTHENTICATION.INFO_TEXT' | translate}}">help_outline</mat-icon></p>
  <ul class="mfa-icon-list">
    <li #li *ngFor="let item of allowedMethods"
      (click)="_selectAuthentication(item, $event)">
      <div fxLayoutAlign="center center" fxLayout="column">
        <span [ngClass]="{'active': (initial_state && item == 'password')}" id="login" class="mfa-method-icon {{'cidaas-icon-'+item}}" title="{{'MFA_REQUIRED.' + item | uppercase | translate}}"></span>
      </div>
        <label>{{'MFA_REQUIRED.' + item | uppercase | translate}}</label>
    </li>
  </ul>
</div>